import { apiClient, type UpdateSiteDto } from '@/libs/api'

export type UpdateSiteRequest = {
  tenantKey: string
  siteId: number
  dto: UpdateSiteDto
}

export const updateSite = async ({
  tenantKey,
  siteId,
  dto
}: UpdateSiteRequest) => {
  const { data, errors } = await apiClient
    ._tenant(tenantKey)
    .sites._id(siteId)
    .$put({ body: dto })
  return { data, errors }
}
